export class MonthReportModel {
    authoritiesInterventionEnum: any;
    authoritiesInterventionEnumString: string;
    Id: number;
    EventName: string;
    EventDescription: string;
    Count: number;
    SiteCount: SiteCountModel[];
}

export class SiteCountModel {
    Name: string;
    Count: number;
}



// WEBPACK FOOTER //
// ./src/app/models/siteCountModel.ts